import { Injectable, Injector } from '@angular/core';



import { $frontendTypes } from './WorkOrders.frontend.types'

@Injectable({ providedIn: 'root' })
export class WorkOrders_FrontendFlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public WorkOrders: WorkOrders_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
